<script setup>
import {onMounted} from 'vue';
onMounted(() => {
})

</script>

<template>
  <router-view></router-view>
</template>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body,
#app {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
